import { IChartDataContent } from '../../../api/charts/types';

export const SOUL_MATRIX_BASE_DATA_CONTENT: IChartDataContent = {
  personality_profile: {
    general: {
      description:
        'Ваша матрица судьбы – это уникальный ключ к пониманию ваших жизненных задач, потенциалов и направлений. ' +
        'Основываясь на комбинации арканов, можно увидеть, какие сферы жизни требуют внимания, ' +
        'какие качества развивать, и какие задачи вы принесли в эту жизнь для реализации.',
      is_unlocked: true,
      positions: [],
      elements: [
        {
          title: 'Личные качества',
          description:
            'Эта категория отвечает за основные черты характера, врожденные склонности и внутреннюю силу человека. ' +
            'Здесь раскрывается, какими качествами человек обладает в полной мере, что помогает ему в жизни, ' +
            'а также над чем стоит работать. Арканы, связанные с личными качествами, указывают на сильные стороны характера, ' +
            'такие как воля, решительность, эмоциональная зрелость, ' +
            'а также возможные слабости, которые могут препятствовать самореализации.',
        },
        {
          title: 'Душевный комфорт',
          description:
            'Душевный комфорт показывает, что необходимо человеку для внутренней гармонии и спокойствия. ' +
            'Арканы этой категории раскрывают, какие внутренние потребности важны для поддержания баланса. ' +
            'Это может быть уединение и время для размышлений, активное взаимодействие с другими людьми или ' +
            'поиск духовных практик. Категория описывает, как человек может восстанавливать энергию и что ' +
            'помогает ему чувствовать себя в гармонии с самим собой.',
        },
        {
          title: 'Самореализация',
          description:
            'Самореализация – это то, как человек проявляет себя в жизни, как реализует свои таланты и возможности. ' +
            'Арканы здесь указывают на направления, в которых человек может добиться успеха, ' +
            'что ему поможет раскрыть свой потенциал и найти свое место в мире. ' +
            'Это может касаться карьеры, творчества, личностного роста или духовного пути. ' +
            'Категория также отражает, каким образом человек может достигнуть личного и профессионального успеха.',
        },
        {
          title: 'Кармический долг',
          description:
            'Эта категория связана с уроками, которые душа принесла из прошлого опыта и которые необходимо ' +
            'проработать в этой жизни. Арканы кармического долга указывают на те аспекты жизни, ' +
            'где человек может столкнуться с трудностями, где необходимо приложить усилия для преодоления ' +
            'внутренних или внешних преград. Проработка кармического долга помогает избавиться от прошлых ' +
            'ограничений и двигаться вперед к гармонии и благополучию.',
        },
        {
          title: 'Предназначение',
          description:
            'Предназначение раскрывает основную задачу души в этой жизни. ' +
            'Арканы этой категории показывают, в чем заключается главная цель существования человека, ' +
            'какие направления жизни требуют наибольшего внимания. Это может быть путь служения другим, ' +
            'развитие творческого потенциала, поиск внутренней истины или реализация лидерских качеств. ' +
            'Категория предназначения описывает высшие цели и задачи, которые человек призван выполнить на своем пути.',
        },
        {
          title: 'Программы',
          description:
            'Программы в матрице судьбы указывают на сценарии жизни, которые человек проходит. ' +
            'Это своеобразные "коды", по которым разворачиваются основные жизненные ситуации. ' +
            'Арканы программ могут показать, с какими повторяющимися ситуациями человек сталкивается, ' +
            'какие ключевые темы будут проходить красной нитью через его жизнь. Проработка программ позволяет ' +
            'человеку лучше понимать свои жизненные уроки и действовать осознанно в различных ситуациях.',
        },
      ],
    },
  },
  strengths: {
    general: {
      description:
        'Сильные стороны в Матрице судьбы раскрывают ваши главные ресурсы и потенциалы. ' +
        'В этой категории анализируются финансы, отношения, личные качества и таланты, которые помогают ' +
        'вам достигать успеха. Программы, заложенные в вашей матрице, указывают на способности к реализации' +
        ' жизненных целей, улучшению материального благополучия и построению гармоничных связей.',
      is_unlocked: true,
      positions: [],
      elements: [
        {
          title: 'Финансы',
          description:
            'В Матрице судьбы можно увидеть ваши сильные стороны в финансовой сфере. ' +
            'Это могут быть навыки управления деньгами, способность привлекать материальные ресурсы и ' +
            'обеспечивать стабильность. Потенциал развития зависит от того, как вы используете свои ресурсы и возможности.',
        },
        {
          title: 'Отношения',
          description:
            'В сфере отношений Матрица судьбы помогает понять, как вы строите связи с другими людьми. ' +
            'Это может быть умение поддерживать гармоничные отношения, строить глубокие связи и проявлять ' +
            'эмоциональную открытость и поддержку в партнерстве.',
        },
        {
          title: 'Личные качества',
          description:
            'Ваша Матрица судьбы раскрывает внутренние личные качества, такие как уверенность, ' +
            'сила характера, эмоциональная стойкость или мудрость. Эти черты помогают вам справляться ' +
            'с жизненными вызовами и двигаться к своим целям.',
        },
        {
          title: 'Таланты',
          description:
            'Матрица судьбы показывает, в каких сферах жизни проявляются ваши таланты. ' +
            'Это могут быть творческие способности, лидерские качества или аналитический склад ума. ' +
            'Важно использовать свои сильные стороны для самореализации и успеха.',
        },
        {
          title: 'Программы',
          description:
            'Программы в плюсе отражают ваш потенциал для личностного роста. Они помогают понять, ' +
            'как лучше использовать свои способности и энергии для достижения успеха и гармонии в различных аспектах жизни.',
        },
      ],
    },
  },
  weaknesses: {
    general: {
      description:
        'Слабые стороны в Матрице судьбы показывают области, которые требуют внимания и проработки. ' +
        'В этой категории рассматриваются препятствия в финансах, отношениях, личных качествах и талантах, ' +
        'которые могут мешать вам на пути к успеху. Программы, заложенные в вашей матрице, указывают на вызовы, ' +
        'которые важно преодолеть, чтобы добиться гармонии и реализовать свои жизненные цели.',
      is_unlocked: true,
      positions: [],
      elements: [
        {
          title: 'Финансы',
          description:
            'В Матрице судьбы можно увидеть ваши слабые стороны в финансовой сфере. ' +
            'Это могут быть трудности с управлением деньгами, импульсивные траты или отсутствие планирования. ' +
            'Важно обратить внимание на свои финансовые привычки, чтобы избежать потерь и создать стабильную основу для будущего благополучия.',
        },
        {
          title: 'Отношения',
          description:
            'В сфере отношений Матрица судьбы указывает на слабые стороны, которые могут проявляться ' +
            'в недопонимании, эмоциональной закрытости или страхе близости. Эти аспекты могут усложнять ' +
            'построение гармоничных связей. Проработка этих моментов поможет укрепить доверие и создать здоровые отношения.',
        },
        {
          title: 'Личные качества',
          description:
            'Матрица судьбы может выявлять слабые стороны ваших личных качеств, такие как упрямство, ' +
            'эмоциональная нестабильность или склонность к самоограничению. Эти черты могут мешать вашему развитию и успеху. ' +
            'Понимание и работа над ними помогут вам достичь внутренней гармонии и самосовершенствования.',
        },
        {
          title: 'Таланты',
          description:
            'Матрица судьбы может показать области, в которых вам сложно проявить свои таланты. ' +
            'Это может быть неуверенность в своих способностях, боязнь проявить себя или недостаток мотивации. ' +
            'Проработка этих аспектов поможет раскрыть ваши истинные способности и достичь профессиональных высот.',
        },
        {
          title: 'Программы',
          description:
            'Программы Матрицы судьбы могут указывать на кармические уроки и задачи, которые требуют проработки. ' +
            'Это могут быть трудности с принятием ответственности, избегание важных жизненных решений или страх перемен. ' +
            'Проработка этих программ даст вам возможность освободиться от ограничений и двигаться вперед.',
        },
      ],
    },
  },
  recommendations: {
    general: {
      description:
        'Проработка в Матрице Судьбы — это важный шаг на пути к самопознанию и развитию. ' +
        'В этой категории мы исследуем глубинные аспекты вашей матрицы, выявляя ключевые блоки и ограничивающие убеждения, ' +
        'которые могут мешать вам достичь гармонии в жизни.' +
        'Каждая из слабых сторон, представленных в вашей матрице, указывает на определенные вызовы, которые требуют внимания. ' +
        'Это могут быть финансовые трудности, сложности в отношениях, или личные качества, которые мешают вам полностью раскрыть свой потенциал. ' +
        'Понимание этих аспектов поможет вам не только преодолеть преграды, но и трансформировать их в источники силы.\n' +
        'Мы предлагаем практические рекомендации и техники, которые помогут вам проработать эти зоны, освободиться ' +
        'от внутреннего сопротивления и наладить гармоничные отношения с окружающим миром. ' +
        'Откройте для себя путь к личной трансформации и научитесь использовать свои вызовы как мощный инструмент для достижения жизненных целей.',
      is_unlocked: true,
      positions: [],
      elements: null,
    },
  },
};
